<template>
    <div class="onboarding">
        <Nav />
        <div class="pt-5 mt-5"></div>
        <div class="mt-5">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>

import Nav from '@/components/Nav.vue'

export default {
    name: 'onboarding',
    components: {
        Nav
    }
}
</script>

<style scoped>

</style>